/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createReorderCategoriesResponseFromDiscriminatorValue, serializeReorderCategoriesRequest, serializeReorderCategoriesResponse, type ErrorResponse, type ReorderCategoriesRequest, type ReorderCategoriesResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/categories/reorder
 */
export interface ReorderRequestBuilder extends BaseRequestBuilder<ReorderRequestBuilder> {
    /**
     * Rearranges one level of the category tree. Position drives the order categories are displayed in across the storefront, the Web Admin and the sales app. Send every category on that level exactly once, in the new order — adding, dropping, or repeating one is a 400. Leave ParentPath empty for the top level.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ReorderCategoriesResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     */
     put(body: ReorderCategoriesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ReorderCategoriesResponse | undefined>;
    /**
     * Rearranges one level of the category tree. Position drives the order categories are displayed in across the storefront, the Web Admin and the sales app. Send every category on that level exactly once, in the new order — adding, dropping, or repeating one is a 400. Leave ParentPath empty for the top level.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: ReorderCategoriesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ReorderRequestBuilderUriTemplate = "{+baseurl}/api/categories/reorder";
/**
 * Metadata for all the requests in the request builder.
 */
export const ReorderRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: ReorderRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createReorderCategoriesResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeReorderCategoriesRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
